module.exports = __webpack_public_path__ + "media/dorobek/assets/images/logo-science-e97fb29ec069fbff46c30e3372b68bec.svg";